module.exports = __webpack_public_path__ + "static/img/Longjie_JIANG.5939538.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/Longjie_JIANG.png
// module id = WkC8
// module chunks = 1